import { render, staticRenderFns } from "./EditButtonConfig.vue?vue&type=template&id=5e86f910&scoped=true&"
import script from "./EditButtonConfig.vue?vue&type=script&lang=js&"
export * from "./EditButtonConfig.vue?vue&type=script&lang=js&"
import style0 from "./EditButtonConfig.vue?vue&type=style&index=0&id=5e86f910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86f910",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e86f910')) {
      api.createRecord('5e86f910', component.options)
    } else {
      api.reload('5e86f910', component.options)
    }
    module.hot.accept("./EditButtonConfig.vue?vue&type=template&id=5e86f910&scoped=true&", function () {
      api.rerender('5e86f910', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Multifunction/modal/EditButtonConfig.vue"
export default component.exports